import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=7bbab9f0&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbab9f0')) {
      api.createRecord('7bbab9f0', component.options)
    } else {
      api.reload('7bbab9f0', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=7bbab9f0&", function () {
      api.rerender('7bbab9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/Location/Main.vue"
export default component.exports